// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "dist/cdn/css/" + {"6890":"session-data","8644":"account","9884":"admin"}[chunkId] + "." + {"6890":"b0a9c0f0","8644":"b0a9c0f0","9884":"b0a9c0f0"}[chunkId] + ".css";
};